import React from "react";
import "./Car.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

const car = props => (
  <div className="CarCard">
    <div>
      <img src={props.image} className="CarImage" />
    </div>
    <div className="CarModelNameCard">{props.modelName}</div>
    <div className="CarVersion">{props.version}</div>
    <div className="hr">
      <hr />
    </div>

    <div className="CarPrice">{props.price}</div>
    <div className="ReservarButton">
      <Link to="/carview">
        <img src="/img/reservar.png" className="ReservarImg" />
      </Link>
    </div>
  </div>
);

export default car;
